import { fieldNamePath } from 'components/page/DatingProfile/DatingProfile.paths'
import { datingProfilePath } from 'components/paths'
import { mergeAllUrls } from 'functions/mergeAllUrls'
import { useLayoutContext } from 'hooks/useLayoutContext'

export const useBaseDatingSettingsUrl = () => {
  const { baseUrl } = useLayoutContext()
  return mergeAllUrls(baseUrl, datingProfilePath, fieldNamePath)
}
